// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* no longer needed */\n/* .actionContainer {\n  float: left;\n  width: 100%;\n} */\n\n.main-grid {\n  float: left;\n  width: 100%;\n}\n\n.info {\n  text-align: start;\n  float: left;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
